<script setup lang="ts">
import type { NavItem } from '@nuxt/content/dist/runtime/types'

const navigation = inject<Ref<NavItem[]>>('navigation', ref([]))

const links = [{
  label: 'Trainingen',
  to: '/trainingen'
},
{
  label: 'Prijzen',
  to: '/prijzen'
}, {
  label: 'Leersysteem',
  to: '/leersysteem/getting-started',
},

{
  label: 'Vaakgestelde vragen',
  to: '/vaakgestelde-vragen'
},
{
  label: 'Over ons',
  to: '/over-ons'
}]
</script>

<template>
  <UHeader :links="links">
    <template #logo>
      <NuxtImg src="logohorecawijs.png" width="175px" alt="horecawijs logo" />
    </template>

    <template #right>
      <UButton label="Inloggen" color="purple" to="https://training.elearn-academie.nl/" target="_blank" />
    </template>

    <template #panel>
      <UNavigationTree :links="links" default-open />
    </template>
  </UHeader>
</template>

<style></style>
